/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingSortCriteria {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingSortCriteria>): AwsSecurityHubFindingSortCriteria {
        let obj = Object.assign(new AwsSecurityHubFindingSortCriteria(), model);
        AwsSecurityHubFindingSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingSortCriteria>): AwsSecurityHubFindingSortCriteria {
        if (!model) return null;
        return AwsSecurityHubFindingSortCriteria.newInstance(<AwsSecurityHubFindingSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingSortCriteria) {
        if (!obj) return;

        models.AwsSecurityHubFindingSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingSortCriteria): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AwsSecurityHubFindingSortColumn;

    ascending: boolean;

}
